import { ShowAllTitle } from '@components/atoms/ShowAllTitle/ShowAllTitle';
import { Carousel } from '@components/molecules/Carousel/Carousel';
import { TvCurrentProgram } from '@components/molecules/TvCurrentProgram/TvCurrentProgram';

export const PageContentElementTvmSports = (element) => {
  if (!element?.sportEntries?.showtimes) return null;
  return (
    <div className="relative pl-4 sm:pl-8 lg:pl-16">
      <ShowAllTitle title={element.title} link={element.title_link} />
      <section>
        <Carousel>
          {element.sportEntries.showtimes.map((showtime) => (
            <TvCurrentProgram
              classProps={{ root: 'flex-none min-w-0 w-72 sm:w-1/2 md:w-1/3 xl:w-1/4 2xl:w-1/5' }}
              key={showtime.id}
              primetime={false}
              channelEntry={showtime}
              channel={showtime.channel}
            />
          ))}
        </Carousel>
      </section>
    </div>
  );
};

export default PageContentElementTvmSports;
